import React, {useState, useEffect} from 'react';
import IconHome from './icons/IconHome.svg'
import IconHomeActive from './icons/IconHomeActive.svg'
import IconContent from './icons/IconContent.svg'
import IconContentActive from './icons/IconContentActive.svg'
import IconCategories from './icons/IconCategories.svg'
import IconCategoriesActive from './icons/IconCategoriesActive.svg'
import IconMyPlaylists from './icons/IconMyPlaylists.svg'
import IconMyPlaylistsActive from './icons/IconMyPlaylistsActive.svg'
import IconSearch from './icons/IconSearch.svg'
import IconSearchActive from './icons/IconSearchActive.svg'
import IconClip from './icons/IconClip.svg'
import IconPromoActive from './icons/IconPromoActive.svg'
import leftArrow from './icons/Arrow_left.svg'
import rightArrow from './icons/Arrow_right.svg'
import { Tooltip } from 'react-tooltip'
import { useNavigate, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux';

const SideBar = (props) => {

    const [activeComponent, setActiveComponent] = useState()

    const { user } = useSelector(state => state.user)     

    const goHomeClickHandler = () => {

        let video_id = localStorage.getItem('video_id') ?  localStorage.getItem('video_id') : 403
        let playlist_id = localStorage.getItem('playlist_id') ?  localStorage.getItem('playlist_id') : 54
        let groupId = localStorage.getItem('group_id') ?  localStorage.getItem('group_id') : 4
        navigate(encodeURI(`/home?g=${groupId}&p=${playlist_id}&v=${video_id}`))
        if (props.setMobileMenuOpen) {props.setMobileMenuOpen(false)}
      } 

    const location = useLocation();
    const navigate = useNavigate()

    const queryParams = new URLSearchParams(location.search);

      useEffect(()=>{
        if(location.pathname === '/' ){
            setActiveComponent(1)
        } else if (location.pathname === '/home'){
            let v = parseInt(queryParams.get("v"))
            if(v === 1526){
                setActiveComponent(6)
            } else {
                setActiveComponent(2)
            }
        } else if (location.pathname === '/category'){
            setActiveComponent(3)
        } else if (location.pathname === '/myPlaylists'){
            setActiveComponent(4)
        } else if(location.pathname === '/search'){ 
            setActiveComponent(5)
        } else {
            setActiveComponent()
        }   
      },[location])

    return (
            <div className='d-flex flex-column w-100 overflow-hidden'>
                <div className='d-none d-md-flex justify-content-end pe-3'>
                    {
                        props.openbar ? 
                        <img 
                            className='m-2 d-none d-lg-block'
                            src={rightArrow} 
                            alt = "right arrow"
                            role='button'
                            style={{height:"1.5rem"}}
                            onClick={()=>props.setOpenbar(false)}
                        /> :
                        <img 
                            className='m-2 d-none d-lg-block    '
                            src={leftArrow} 
                            alt = "left arrow"
                            role='button'
                            style={{height:"1.5rem"}}
                            onClick={()=>props.setOpenbar(true)}
                        />
                    }
                </div>
                <div className='d-flex flex-column align-items-center p-3 w-100 overflow-hidden'
                    style={{gap:'1rem'}}
                >
                        {
                            activeComponent === 5 ?
                            <div className=  {props.openbar ? 'bg-info p-2 rounded d-flex align-items-center overflow-hidden' : 'bg-info p-2 rounded d-flex w-100 align-items-center overflow-hidden'}
                            >
                                <img 
                                    className=''
                                    data-tooltip-id="search-tooltip"  
                                    data-tooltip-content="Search"
                                    src={IconSearch}
                                    alt = "search icon"
                                    style={{height:"1.625rem"}}
                                />
                                <div className= { props.openbar ?  'd-none text-blueazur ps-3' : 'd-block ps-3 text-blueazur'  }>
                                    Search
                                </div>
                            </div>
                            :
                            <div className= 'p-2 rounded d-flex align-items-center w-100 overflow-hidden'
                                role='button'
                            onClick={() => {
                                navigate('/search');
                                if (props.setMobileMenuOpen) {
                                    props.setMobileMenuOpen(false)
                                }
                            }}
                            >
                                <img 
                                    className=''
                                    data-tooltip-id="search-tooltip"  
                                    data-tooltip-content="Search"
                                    src={IconSearchActive} 
                                    alt = "search icon"
                                    role='button'
                                    style={{height:"1.625rem"}}
                                />
                                <div className= { props.openbar ?  'd-none text-info ps-3' : 'd-block ps-3 text-info'  }>
                                    Search
                                </div>
                            </div>
                        }   
                        <Tooltip id = 'search-tooltip' className='bg-info' style={{zIndex:'1000'}}/> 

                        {
                            activeComponent === 1 ?
                            <div className=  {props.openbar ? 'bg-info p-2 rounded d-flex align-items-center overflow-hidden' : 'bg-info p-2 rounded d-flex w-100 align-items-center overflow-hidden'}
                            >
                                <img 
                                        data-tooltip-id="home-tooltip"  
                                        data-tooltip-content="Home"
                                        className=''
                                        src={IconHome} 
                                        alt = "home icon"
                                        style={{height:"1.625rem"}}
                                    />
                                <div className= { props.openbar ?  'd-none text-blueazur ps-3' : 'd-block ps-3 text-blueazur'  }>
                                    Home
                                </div>
                            </div>
                            :
                            <div className= 'p-2 rounded d-flex align-items-center w-100 overflow-hidden'
                                role='button'
                            onClick={() => {
                                navigate('/');
                                if (props.setMobileMenuOpen) {
                                    props.setMobileMenuOpen(false)
                                    
                                 }
                            }}
                            >
                                <img 
                                    data-tooltip-id="home-tooltip"  
                                    data-tooltip-content="Home"
                                    className=''
                                    src={IconHomeActive} 
                                    alt = "home icon"
                                    role='button'
                                    style={{height:"1.625rem"}}
                                />
                                <div className= { props.openbar ?  'd-none text-info ps-3' : 'd-block ps-3 text-info'  }>
                                    Home
                                </div>
                            </div>
                        } 
                            <Tooltip id = 'home-tooltip' className='bg-info' style={{zIndex:'1000'}}/>

                        {
                            activeComponent === 2 ?
                            <div className=  {props.openbar ? 'bg-info p-2 rounded d-flex align-items-center overflow-hidden' : 'bg-info p-2 rounded d-flex w-100 align-items-center overflow-hidden'}
                            >
                                <img 
                                data-tooltip-id="content-tooltip"  data-tooltip-content="Content"
                                className=''
                                src={IconContent} 
                                alt = "content icon"
                                style={{height:"1.625rem"}}
                            />
                                <div className= { props.openbar ?  'd-none text-blueazur ps-3' : 'd-block ps-3 text-blueazur'  }>
                                    Content
                                </div>
                            </div>
                            :
                            <div className= 'p-2 rounded d-flex align-items-center w-100 overflow-hidden'
                                role='button'
                                onClick={()=>goHomeClickHandler()}
                            >
                            <img 
                                data-tooltip-id="content-tooltip"  
                                data-tooltip-content="Content"
                                className=''
                                src={IconContentActive} 
                                alt = "content icon"
                                role='button'
                                style={{height:"1.625rem"}}
                            />
                                <div className= { props.openbar ?  'd-none text-info ps-3' : 'd-block ps-3 text-info'  }>
                                    Content
                                </div>
                            </div>

                        }
                        <Tooltip id = 'content-tooltip' className='bg-info' style={{zIndex:'1000'}}/>
                        {
                            activeComponent === 3 ?
                            <div className=  {props.openbar ? 'bg-info p-2 rounded d-flex align-items-center overflow-hidden' : 'bg-info p-2 rounded d-flex w-100 align-items-center overflow-hidden'}
                            >
                                <img 
                                    className=''
                                    data-tooltip-id="categories-tooltip"  
                                    data-tooltip-content="Categories"
                                    src={IconCategoriesActive} 
                                    alt = "categories icon"
                                    style={{height:"1.625rem"}}
                                />
                                <div className= { props.openbar ?  'd-none text-blueazur ps-3' : 'd-block ps-3 text-blueazur'  }>
                                    Categories
                                </div>
                            </div>
                            :
                            <div className= 'p-2 rounded d-flex align-items-center w-100 overflow-hidden'
                                role='button'
                                onClick={()=>{navigate('/category'); if (props.setMobileMenuOpen) {props.setMobileMenuOpen(false)}}}
                            >
                                <img 
                                    className=''
                                    data-tooltip-id="categories-tooltip"  
                                    data-tooltip-content="Categories"
                                    src={IconCategories} 
                                    alt = "categories icon"
                                    role='button'
                                    style={{height:"1.625rem"}}
                                    
                                />
                                <div className= { props.openbar ?  'd-none text-info ps-3' : 'd-block ps-3 text-info'  }>
                                    Categories
                                </div>
                            </div>

                        }   
                        <Tooltip id = 'categories-tooltip' className='bg-info' style={{zIndex:'1000'}}/>
                        { user && user.first_name ?
                            activeComponent === 4 ?
                            <div className=  {props.openbar ? 'bg-info p-2 rounded d-flex align-items-center overflow-hidden' : 'bg-info p-2 rounded d-flex w-100 align-items-center overflow-hidden'}
                            >
                                <img 
                                    className=''
                                    data-tooltip-id="myplaylists-tooltip"  
                                    data-tooltip-content="My Playlists"
                                    src={IconMyPlaylistsActive} 
                                    alt = "my playlists icon"
                                    style={{height:"1.625rem"}}
                                />
                                <div className= { props.openbar ?  'd-none text-blueazur ps-3 text-nowrap' : 'd-block ps-3 text-blueazur text-nowrap'  }>
                                    My Playlists
                                </div>
                            </div>
                            :
                            <div className= 'p-2 rounded d-flex align-items-center w-100 overflow-hidden'
                                role='button'
                                onClick={()=>{navigate('/myPlaylists'); if (props.setMobileMenuOpen) {props.setMobileMenuOpen(false)}}}
                            >
                                <img 
                                    className=''
                                    data-tooltip-id="myplaylists-tooltip"  
                                    data-tooltip-content="My Playlists"
                                    src={IconMyPlaylists} 
                                    alt = "my playlists icon"
                                    role='button'
                                    style={{height:"1.625rem"}}
                                />
                                <div className= { props.openbar ?  'd-none text-info ps-3 text-nowrap' : 'd-block ps-3 text-info text-nowrap'  }>
                                    My Playlists
                                </div>
                            </div>: ""
                        }  
                        <Tooltip id = 'myplaylists-tooltip' className='bg-info' style={{zIndex:'1000'}}/> 
                        {
                            activeComponent === 6 ?
                            <div className=  {props.openbar ? 'bg-info p-2 rounded d-flex align-items-center overflow-hidden' : 'bg-info p-2 rounded d-flex w-100 align-items-center overflow-hidden'}
                            >
                                <img 
                                data-tooltip-id="promo-tooltip"  data-tooltip-content="Promo"
                                className=''
                                src={IconPromoActive} 
                                alt = "promo icon"
                                style={{width:"1.625rem"}}
                            />
                                <div className= { props.openbar ?  'd-none text-blueazur ps-3' : 'd-block ps-3 text-blueazur'  }>
                                    Promo
                                </div>
                            </div>
                            :
                            <div className= 'p-2 rounded d-flex align-items-center w-100 overflow-hidden'
                                role='button'
                                onClick={()=>navigate('/home?p=342&v=1526&g=24')}
                            >
                            <img 
                                data-tooltip-id="cpromo-tooltip"  
                                data-tooltip-content="Promo"
                                className=''
                                src={IconClip} 
                                alt = "promo icon"
                                role='button'
                                style={{width:"1.625rem"}}
                            />
                                <div className= { props.openbar ?  'd-none text-info ps-3' : 'd-block ps-3 text-info'  }>
                                    Promo
                                </div>
                            </div>

                        } 
                        <Tooltip id = 'promo-tooltip' className='bg-info' style={{zIndex:'1000'}}/> 
                </div>
            </div>
    );
};

export default SideBar;
